module.exports = __webpack_public_path__ + "assets/doc-3b299de880160f1fd2e55aa86550cc7a.svg";